/* Toggle for snippets/gut-barrier-widget.liquid: sets data-mode and aria-pressed and swaps each
   swap target's text from its data-low / data-fiber attribute. Loaded by how-it-works and
   roots-good-years only when the widget is enabled; re-inits on shopify:section:load. */
(function () {
  function initCard(card) {
    if (!card || card.dataset.hiwBarrierInit === '1') return;
    var btns = card.querySelectorAll('.hiw-barrier__toggle-btn');
    if (btns.length < 2) return;
    var swaps = card.querySelectorAll('[data-low][data-fiber]');

    function setMode(mode) {
      if (card.getAttribute('data-mode') === mode) return;
      card.setAttribute('data-mode', mode);
      btns.forEach(function (b) {
        var on = b.dataset.mode === mode;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      swaps.forEach(function (el) {
        var next = mode === 'fiber' ? el.getAttribute('data-fiber') : el.getAttribute('data-low');
        if (next != null) el.textContent = next;
      });
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.mode); });
    });
    card.dataset.hiwBarrierInit = '1';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.hiw-barrier').forEach(initCard);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
